!function () {
  const storageKey = 'dbtfyCartCountdown';
  const selector = '[data-snippet-type="cart-countdown"]';

  function readStoredTimer() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  }

  function writeStoredTimer(timer) {
    window.localStorage.setItem(storageKey, JSON.stringify(timer));
  }

  function clearStoredTimer() {
    window.localStorage.removeItem(storageKey);
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCartCountdown(el) {
    if (el.dbtfyCartCountdownInitialized) return;
    el.dbtfyCartCountdownInitialized = true;

    const settings = theme.helpers.safelyParseJson(el.dataset.snippetSettings);

    if (!settings || !settings.thresholdSeconds) return;

    const thresholdMs = settings.thresholdSeconds * 1000;
    const labelEl = el.querySelector('[data-cart-countdown-label]');
    const timerEl = el.querySelector('[data-cart-countdown-timer]');
    const endMessageEl = el.querySelector('[data-cart-countdown-end-message]');

    function showExpired() {
      if (labelEl) labelEl.hidden = true;
      if (timerEl) timerEl.hidden = true;
      if (endMessageEl) endMessageEl.hidden = false;
    }

    
    if (!settings.itemCount) {
      clearStoredTimer();
      return;
    }

    const now = Date.now();
    const today = new Date().toDateString();
    const stored = readStoredTimer();

    
    if (stored && stored.date === today && stored.expired) {
      showExpired();
      return;
    }

    let start;

    if (!stored || stored.date !== today) {
      start = now;
      writeStoredTimer({ start: start, date: today, expired: false });
    } else {
      start = stored.start;
    }

    function tick() {
      const remainingMs = thresholdMs - (Date.now() - start);

      if (remainingMs <= 0) {
        clearInterval(el.dbtfyCartCountdownIntervalId);
        writeStoredTimer({ start: start, date: today, expired: true });
        showExpired();
        return;
      }

      const totalSeconds = Math.floor(remainingMs / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      if (timerEl) timerEl.textContent = pad(minutes) + ':' + pad(seconds);
    }

    tick();
    el.dbtfyCartCountdownIntervalId = setInterval(tick, 1000);
  }

  function scanForCountdown(root) {
    root.querySelectorAll(selector).forEach(initCartCountdown);
  }

  function init() {
    scanForCountdown(document);

    const observerTarget = document.getElementById('CartContainer');

    if (!observerTarget) return;

    new MutationObserver(function () {
      scanForCountdown(observerTarget);
    }).observe(observerTarget, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}();
